import {DateRangeConstraintDataDto} from "../../../../../../common/apis/datatype/DataTypeConstraintDto";
import {ConstraintPluginProps} from "../ConstraintDataPlugin";
import {Grid} from "@mui/material";
import {t} from "../../../../../../store/localization/TranslMessasge";
import {DataTypeTranslationKey} from "../../DataTypeTranslationKey";
import React from "react";
import {DatePicker} from "../../../../../../components/fields/time/DatePicker";


export function DateRangeConstraintPluginForm(props: Readonly<ConstraintPluginProps<DateRangeConstraintDataDto>>) {
    const {data, onChange, errors} = props;

    function updateMin(date: string | null | undefined) {
        if (!date) {
            onChange({
                ...data,
                dateFrom: undefined
            });
            return;
        }

        onChange({
            ...data,
            dateFrom: date
        });
    }

    function updateMax(date: string | null | undefined) {
        if (!date) {
            onChange({
                ...data,
                dateTo: undefined
            });
            return;
        }

        onChange({
            ...data,
            dateTo: date
        });
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <DatePicker
                        label={t(DataTypeTranslationKey.MIN_VALUE)}
                        value={data.dateFrom}
                        onChange={updateMin}
                        error={errors?.min} />
            </Grid>
            <Grid item xs={6}>
                <DatePicker
                        label={t(DataTypeTranslationKey.MAX_VALUE)}
                        value={data.dateTo}
                        onChange={updateMax}
                        error={errors?.max} />
            </Grid>
        </Grid>
    );
}
